<template>
     <div class="loadingWrap topbox">
            <div class="loading">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                     <p>正在为您出奖，请耐心等待...</p>
            </div>
     </div>
</template>

<style type="text/css">
  .loadingWrap{ width: 100%; height: 100vh;  background-color: rgba(0,0,0,0.8); position: fixed; z-index: 9999; top:0; left:0;   align-items: center;}
  .imagesWrap img{ width: 100%; }
  .loadingWrap p{ font-size: 0.28rem;
    width: 100%;
    text-align: center;
    display: flex;
    height: 0.5rem;
    justify-content: center;
    left: 0;
    line-height: 1.2rem;
    position: absolute; }
  .loading{
                width: 60px;
    height: 40px;
    margin: 0 auto;
    margin-top: -150px;
    overflow: visible;
        }
        .loading span{
            display: inline-block;
            width: 8px;
            height: 100%;
            border-radius: 4px;
            background: lightgreen;
            -webkit-animation: load 1s ease infinite;
        }
        @-webkit-keyframes load{
            0%,100%{
                height: 40px;
                background: lightgreen;
            }
            50%{
                height: 70px;
                margin: -15px 0;
                background: lightblue;
            }
        }
        .loading span:nth-child(2){
            -webkit-animation-delay:0.2s;
        }
        .loading span:nth-child(3){
            -webkit-animation-delay:0.4s;
        }
        .loading span:nth-child(4){
            -webkit-animation-delay:0.6s;
        }
        .loading span:nth-child(5){
            -webkit-animation-delay:0.8s;
        }

   @media screen and (max-width: 450px) {
        .loadingWrap img{ width: 100%; }
  } 
</style>
<script type="text/javascript">
	export default{
		name:'loadingCj',
		props:[],
		data(){
			return {
			}
		},
		mounted (){
		},
		methods:{
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/loadingCj.vue